import {observable, action} from 'mobx';
import modalAction from '~/utils/modalStack';

const {pushStack, popStack} = modalAction;

class Store {
  @observable openKeys = '';

  @observable showAppSwitcher = false;

  @observable subMenuRef = [];

  @observable isHover = false;

  @action
  setOpenKeys(keys) {
    this.openKeys = keys;
  }

  @action.bound
  toggleAppSwitcher(boolean = !this.showAppSwitcher) {
    this.showAppSwitcher = boolean;
    if (boolean) {
      pushStack(() => this.toggleAppSwitcher(false));
    } else {
      popStack();
    }
  }

  @action.bound
  toggleSubMenu(id, boolean) {
    this.subMenuRef[id].open = boolean;
  }

  @action.bound
  setIsHover(data) {
    this.isHover = data;
  }
}

export default new Store();
